import { useState } from "react";
import { Paper, Tabs, Tab, Typography } from "@mui/material";
import EventHistoryList from "./EventHistoryList";
import StatusHistoryList from "./StatusHistoryList";
import { TabPanel } from "../Tab/TabPanel";
import { EventAndStatusHistoryProps } from "./types";
import { useStyles } from "./History.styles";

export default function EventAndStatusHistory({
	eventHistoryList,
	statusHistoryList,
	arrivals,
}: EventAndStatusHistoryProps) {
	const classes = useStyles();
	const [activeTab, setActiveTab] = useState<number>(0);
	const handleTabChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	return (
		<Paper square className={classes.eventAndStatusHistoryContainer}>
			<Tabs
				value={activeTab}
				indicatorColor="secondary"
				textColor="inherit"
				onChange={handleTabChange}
				variant="fullWidth"
				aria-label="Event and Status History Tabs"
			>
				<Tab label="Events" id="tab-events" aria-controls="tabpanel-events" className={classes.tab} />
				<Tab label="Statuses" id="tab-statuses" aria-controls="tabpanel-statuses" className={classes.tab} />
			</Tabs>
			<TabPanel value={activeTab} index={0}>
				{eventHistoryList && eventHistoryList.length > 0 ? (
					<EventHistoryList eventHistoryList={eventHistoryList} />
				) : (
					<Typography className={classes.noResultFound}>No events found</Typography>
				)}
			</TabPanel>
			<TabPanel value={activeTab} index={1}>
				{statusHistoryList && statusHistoryList.length > 0 ? (
					<StatusHistoryList statusHistoryList={statusHistoryList} arrivals={arrivals} />
				) : (
					<Typography className={classes.noResultFound}>No statuses found</Typography>
				)}
			</TabPanel>
		</Paper>
	);
}
